export default "__VITE_ASSET__DC7sOgq$__"